import { render } from "./AddAppToHome.vue?vue&type=template&id=d3409ed2&scoped=true"
import script from "./AddAppToHome.vue?vue&type=script&lang=js"
export * from "./AddAppToHome.vue?vue&type=script&lang=js"

import "./AddAppToHome.vue?vue&type=style&index=0&id=d3409ed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3409ed2"]])

export default __exports__